const isValidValue = (key, parameters) => {
  return parameters[key] !== null &&
    parameters[key] !== undefined &&
    parameters[key] !== ''
}

const getParameterString = (parameters) => {
  if (!parameters) return ''

  const paramList = Object.keys(parameters)
    .filter(key => isValidValue(key, parameters))
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`)

  return `?${paramList.join('&')}`
}

export default getParameterString
